export const OCR_MANAGER_RETURN_GRACE_KEY = 'kgolf_ocr_manager_return_grace_until';
export const OCR_MANAGER_RETURN_GRACE_MS = 15 * 60 * 1000;
export function normalizeOcrFocusStatus(status) {
    return status === 'NO_RECEIPT' ? 'MISSING_RECEIPT' : status;
}
export function buildOcrBookingDetailUrl({ bookingId, paymentId, seatIndex, status, date, filter, reason, }) {
    const params = new URLSearchParams({
        focus: 'receipt',
        paymentId,
        seat: String(seatIndex),
        status: normalizeOcrFocusStatus(status),
        returnTo: 'ocr-analysis',
        ocrDate: date,
        ocrFilter: filter,
        ocrPaymentId: paymentId,
    });
    if (reason) {
        params.set('reason', reason);
    }
    return `/pos/booking/${bookingId}?${params.toString()}`;
}
export function isOcrBookingReturnPath(pathname, search) {
    const params = new URLSearchParams(search);
    return pathname.startsWith('/pos/booking/') && params.get('returnTo') === 'ocr-analysis';
}
export function getOcrManagerReturnGraceExpiry(now = Date.now()) {
    return now + OCR_MANAGER_RETURN_GRACE_MS;
}
export function isOcrManagerReturnGraceActive(rawValue, now = Date.now()) {
    if (!rawValue)
        return false;
    const expiresAt = Number(rawValue);
    return Number.isFinite(expiresAt) && expiresAt > now;
}
